import { render, staticRenderFns } from "./MeetingSummaryCard.vue?vue&type=template&id=116d4337&scoped=true&"
import script from "./MeetingSummaryCard.vue?vue&type=script&lang=js&"
export * from "./MeetingSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d4337",
  null
  
)

export default component.exports